import React from 'react'

import { CUSTOM_TEMPLATE } from '../../_templates/Constants'
import { HORIZONTAL_TEMPLATE, VERTICAL_TEMPLATE } from '../../_templates/Templates'
import { Title } from '../../../../../packages/kiti/components/presentation/Text'
import { usePdfOptionsForm } from '../../../../../components/pdf/options/_form/PdfOptionsFormHandler'
import { FlexCol } from '../../../../../components/structure/FlexGrid'
import Accordion from '../../../../../components/structure/accordion/Accordion'
import AccordionHeader from '../../../../../components/structure/accordion/AccordionHeader'
import Grid from '../../../../../components/pdf/Grid'
import AccordionContent from '../../../../../components/structure/accordion/AccordionContent'
import TemplateBgColor from './Template/TemplateBgColor'
import TemplateSize from './Template/TemplateSize'
import TemplateImportSVG from './Template/TemplateImportSVG'

export const TemplateSection = () => {
  const form = usePdfOptionsForm()

  if (![CUSTOM_TEMPLATE, HORIZONTAL_TEMPLATE, VERTICAL_TEMPLATE].includes(form.template)) return false

  return (
    <FlexCol>
      <Accordion startsOpen lineBorder mediumPadding={true} noRadius>
        <AccordionHeader>
          <Grid justify="space-between">
            <Title size="h6" noMargin>
              Template
            </Title>
          </Grid>
        </AccordionHeader>
        <AccordionContent>
          <TemplateImportSVG />
          <TemplateSize />
          <TemplateBgColor />
        </AccordionContent>
      </Accordion>
    </FlexCol>
  )
}

export default TemplateSection
